import {useStyles} from '../../../../shared/hooks/styles';

export const GetDesktopStyles = () => {
  return useStyles(({theme}) => ({
    colBodyMessageText: {
      ...theme.fonts.h5Light,
      color: theme.color.textColor,
    },
    colBodyMessageTextNotRead: {
      ...theme.fonts.h5,
      color: theme.color.textColor,
    },
    colBodyText: {
      ...theme.fonts.h5Light,
      color: theme.color.labelText,
    },
    colBodyTextNotRead: {
      ...theme.fonts.h5,
      color: theme.color.textColor,
    },
    icon: {
      height: 12,
      width: 12,
      color: theme.color.primaryColor,
    },
    colStatus: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
    },
    colText: {
      marginRight: 20,
      flexGrow: 1,
      flexShrink: 1,
      maxWidth: 900,
    },
    colDate: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 20,
    },
    colTime: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
    },
  }));
};

export const GetMobileStyles = () => {
  const styles = useStyles(({theme}) => ({
    container: {
      borderColor: theme.color.borderColor,
      borderTopWidth: 1,
      borderStyle: 'solid',
    },
    item: {
      borderBottomWidth: 1,
      borderStyle: 'solid',
      borderColor: theme.color.borderColor,
      position: 'relative',
      paddingBottom: 24,
      paddingTop: 8,
      minHeight: 71,
    },
    itemContent: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    itemTextWrapper: {
      flex: 1,
      width: 350,
    },
    itemText: {
      ...theme.fonts.bodySmallLight,
      color: theme.color.textColor,
    },
    itemTextNotRead: {
      ...theme.fonts.bodySmall,
      color: theme.color.textColor,
    },
    itemDateTimeWrapper: {
      height: 24,
      position: 'absolute',
      right: 0,
      bottom: 0,
    },
    itemDateTime: {
      ...theme.fonts.label,
      color: theme.color.labelText,
    },
    iconWrapper: {
      flexBasis: 28,
      flexShrink: 0,
      flexGrow: 0,
      paddingRight: 16,
    },
    icon: {
      height: 12,
      width: 12,
      color: theme.color.primaryColor,
    },
  }));
  return styles;
};
